import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { multilanguage } from "redux-multilanguage";


const NavMenu = ({ strings, menuWhiteClass, sidebarMenu, categories, products, currentLanguageCode }) => {
    return (
        <div
            className={` ${sidebarMenu
                ? "sidebar-menu"
                : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
                } `}
        >
            <nav>
                <ul>
                    <li>
                        <Link to={process.env.PUBLIC_URL + "/shop?category=all"}>
                            {strings['appPages']['navShop']}
                        </Link>
                        <ul className="mega-menu">
                            <li>
                                <ul>
                                    {
                                        categories.map((item, i) => {
                                            return <li key={i}>
                                                <a href={process.env.PUBLIC_URL + "/shop?category=" + item.categoryCode}>
                                                    {String(item.categoryName[currentLanguageCode]).toLocaleUpperCase(currentLanguageCode)}
                                                </a>
                                            </li>
                                        })
                                    }

                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li className="mega-menu-img">
                                        <a href={process.env.PUBLIC_URL + "/shop?category=all"}>
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/img/banner/iola_category_banner_4.jpg"
                                                }
                                                alt="IOLA FASHION iola fashion iolafashion"
                                            />
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li className="mega-menu-img">
                                        <a href={process.env.PUBLIC_URL + "/shop?category=all"}>
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/img/banner/iola_category_banner_3.jpg"
                                                }
                                                alt="IOLA FASHION iola fashion iolafashion"
                                            />
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <Link to={process.env.PUBLIC_URL + "/shop?product=all"}>
                            {strings['appPages']['newSeason']}
                        </Link>
                        <ul className="mega-menu">
                            <li>
                                <ul>
                                    {
                                        products.map((item, i) => {
                                            return <li key={i}>
                                                <a href={process.env.PUBLIC_URL + "/shop?product=" + item.seoName}>
                                                    {String(item.productName[currentLanguageCode]).toLocaleUpperCase(currentLanguageCode)}
                                                </a>
                                            </li>
                                        })
                                    }
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li className="mega-menu-img">
                                        <a href={process.env.PUBLIC_URL + "/shop?product=all"}>
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/img/banner/iola_category_banner_7.jpg"
                                                }
                                                alt="IOLA FASHION iola fashion iolafashion"
                                            />
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li className="mega-menu-img">
                                        <a href={process.env.PUBLIC_URL + "/shop?product=all"}>
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/img/banner/iola_category_banner_8.jpg"
                                                }
                                                alt="IOLA FASHION iola fashion iolafashion"
                                            />
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <Link to={process.env.PUBLIC_URL + "/about"}>
                            {strings["about_us"]}
                        </Link>
                    </li>
                    <li>
                        <Link to={process.env.PUBLIC_URL + "/contact"}>
                            {strings["contact_us"]}
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

NavMenu.propTypes = {
    menuWhiteClass: PropTypes.string,
    sidebarMenu: PropTypes.bool,
    strings: PropTypes.object
};

export default multilanguage(NavMenu);
